import getComponentClassName from './getComponentClassName';

/**
 * @param name: if parent ? camelCase : PascalCase
 * @param parent: PascalCase
 * @param modifier: camelCase
 * @returns {string}
 */
const getComponentModifierClassName = ({
  name,
  parent,
  modifier,
}: {
  name: string;
  parent?: string;
  modifier: string;
}): string => {
  const componentName = getComponentClassName(name, parent);
  return `${componentName}--${modifier}`;
};

export default getComponentModifierClassName;
